var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty"},[_c('img',{staticClass:"img",attrs:{"src":"https://img.xunfei.cn/mall/ifly-mall-web/common/applet_move_version.jpg?q=80&c=1&f=webp"}}),_c('div',{staticClass:"text"},[_vm._v(" 抱歉，该区域暂未开放门店。欢迎扫码进入讯飞商城，足不出户即可选购心仪产品！ ")])])
}]

export { render, staticRenderFns }